import React, { useState, useEffect, useCallback } from 'react'

import {
    Button,
    CircularProgress,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    IconButton,
    Typography,
    TextField,
    MenuItem,
    Switch,
    Icon
} from '@material-ui/core'

import moment from 'moment'

import { DatePicker } from '@material-ui/pickers'

import { api } from '../../../services/api'

import { ArrowBackIosOutlined, ArrowForwardIosOutlined } from '@material-ui/icons'

import { useDispatch } from 'react-redux'

import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
    dialogActions: {
        justifyContent: 'flex-start',
        padding: '0px 24px',
        marginTop: 24
    },
    checkbox: {
        '&.Mui-disabled.Mui-checked .MuiIconButton-label .MuiSvgIcon-root': {
            fill: '#A2A1A4'
        }
    },
    avatar: {
        background: '#C4C4C4',
        height: '32px',
        width: '32px',
        marginTop: '12px',
        marginBottom: '12px'
    },
    textField: {
        marginBottom: '8px',
        '& .MuiTextField-root': {
            minWidth: '100%',
            marginBottom: '16px'
        },
        '& .MuiFilledInput-underline': {
            minWidth: '100%'
        },
        '$ .MuiInputLabel-filled.MuiInputLabel-shrink': {
            transform: `translate(14px, 10px) scale(0.75) !important`
        }
    },
    sharingWrapper: {
        height: 56,
        width: '100%',
        padding: '0px 12px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderRadius: 6,
        background: '#F9F9F9'
    },
    switchRoot: {
        width: 51,
        height: 31,
        padding: 0
    },
    switchBase: {
        padding: 0,
        margin: 2,
        '&$checked': {
            transform: 'translateX(20px)',
            color: theme.palette.common.white,
            '& + $track': {
                backgroundColor: '#6B4AD6',
                opacity: 1
            },
            '& .far::before': {
                color: '#6B4AD6'
            }
        },
        '&$focusVisible $thumb': {
            color: '#6B4AD6'
            //border: "6px solid #fff",
        }
    },
    thumb: {
        width: 27,
        height: 27,
        background: '#F3F3F3',
        border: '1px solid #E5E5E5',
        borderRadius: '50%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        '& .far': {
            color: '#A2A1A4',
            fontSize: '13px',
            lineHeight: '15px'
        }
    },
    track: {
        borderRadius: 100,
        padding: 2,
        backgroundColor: '#D0CFD2',
        opacity: 1,
        transition: theme.transitions.create(['background-color'])
    },
    checked: {},
    calendarButton: {
        '& svg': {
            fill: theme.palette.primary.main
        }
    },
    calendarHeaderButtons: {
        fill: theme.palette.primary.main
    },
    datePicker: {
        '& .MuiInputLabel-filled': {
            transform: 'translate(14px, 20px) scale(1)'
        },
        '& .MuiInputLabel-shrink': {
            transform: 'translate(14px, 10px) scale(0.75)'
        },
        '&:nth-child(1)': {
            marginRight: '16px !important'
        }
    },
    bodyText: {
        fontSize: 16,
        fontWeight: '600',
        color: '#1A1A35',
        lineHeight: '21px',
        marginBottom: 24
    }
}))

const DuplicateDialog = (props) => {
    const classes = useStyles()
    const dispatch = useDispatch()
    const [isCalendarOpen, setIsCalendarOpen] = useState(false)
    const [date, setDate] = useState(null)
    const [loading, setLoading] = useState(false)
    const [dates, setDates] = useState([])

    let { isShown, setIsShown, duplicate, visit } = props

    const fetchVisits = useCallback(
        async () => {
            try {

                setLoading(true)

                let { data } = await api.get(`/groomingVisits/${props.facility._id}?date=${moment().format('YYYY-MM-DD')}&allDates=true`)

                const type = visit.grooming_service_type || 'haircut'
                const duration = visit.duration || 90
                let goodDates = data.shifts.filter(s => s?.permitted_grooming_services?.includes(type) && s.remaining_minutes >= duration).map(s => s.date)

                console.log({ goodDates })

                goodDates = goodDates.filter(day => {
                    const onDay = data.visits.filter(v => v?.dates?.includes(day))
			        const shiftsOnDay = data.shifts.filter(v => v.date === day)
			        const total = onDay.length ? onDay.reduce((a, b) => a + b.duration, 0) : 0
			        const shifted = shiftsOnDay.length ? shiftsOnDay.reduce((a, b) => a + b.total_shift_minutes, 0) : 0
			        const diff = shifted - total

                    return diff > duration
                })

                
                setDates(goodDates)

                setLoading(false)

            } catch (e) {
                console.log(e)
                setLoading(false)
            }
        },
        []
    )


    useEffect(() => {
        if (isShown) fetchVisits()
    }, [isShown])




    const shouldDisable = (d) => {
        return !dates.includes(d.format('YYYY-MM-DD'))
    }


    return (
        <Dialog
            open={isShown}
            className={classes.dialog}
            onClose={() => {
                setDate(null)
                setIsShown(false)
            }}
            PaperProps={{
                style: {
                    minWidth: '448px',
                    maxWidth: '448px',
                    width: '448px',
                    padding: '24px 0px'
                }
            }}>
            <DialogTitle
                style={{
                    marginBottom: 18,
                    padding: '0px 24px'
                }}>
                RE-BOOK APPOINTMENT
            </DialogTitle>
            <DialogContent
                style={{
                    padding: '0px 24px'
                }}>
                <div className={classes.textField}>
                    <Typography variant="body1" className={classes.bodyText}>
                    Re-booking will not impact this appointment. Instead it will create a new appointment on the date selected, with the same settings as this appointment.
                    </Typography>
                    <DatePicker
                        disableToolbar
                        style={{
                            minWidth: '400px',
                            margin: 0
                        }}
                        disabled={loading}
                        InputAdornmentProps={{
                            position: 'start',
                            component: () => (
                                <IconButton onClick={() => setIsCalendarOpen(true)}>
                                    <Icon
                                        className="far fa-calendar-alt"
                                        style={{
                                            fontSize: '1.325rem'
                                        }}
                                    />
                                </IconButton>
                            )
                        }}
                        shouldDisableDate={(d) => shouldDisable(d)}
                        InputProps={{
                        }}
                        variant="inline"
                        format="MM/DD/YYYY"
                        margin="normal"
                        label="Date"
                        inputVariant="filled"
                        value={date}
                        onChange={(date) => {
                            
                            if (date && date.isValid() && dates.includes(date.format('YYYY-MM-DD'))) setDate(date.clone().hour(12))
                        }}
                        className={classes.datePicker}
                        rightArrowIcon={<ArrowForwardIosOutlined className={classes.calendarHeaderButtons} />}
                        leftArrowIcon={<ArrowBackIosOutlined className={classes.calendarHeaderButtons} />}
                        KeyboardButtonProps={{
                            'aria-label': 'Date',
                            className: classes.calendarButton
                        }}
                        disablePast
                    />

                </div>

            </DialogContent>
            <DialogActions className={classes.dialogActions}>
                <Button
                    disabled={!date || loading || !moment(date).isValid()}
                    variant="contained"
                    onClick={() => {
                        setLoading(true)
                        duplicate(date)
                        setTimeout(() => {
                            setLoading(false)
                            setIsShown(false)
                            setDate(null)
                        }, 1000)

                    }}
                    color="secondary">
                    {loading ? <CircularProgress /> : 'Confirm'}
                </Button>
                <Button
                    variant="outlined"
                    onClick={() => {
                        setDate(null)
                        setIsShown(false)
                    }}
                    color="secondary">
                    Cancel
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default DuplicateDialog
